module.exports = __webpack_public_path__ + "static/media/key.0cc99172.svg";